import { useSafeState } from '#hooks';
import { FC } from 'react';
import { AccountPaymentMode, AccountType, B2bAccount, UserV3 } from '#types';
import { EditB2bAccount } from './editB2b.component';

export const CreateNewB2bAccount: FC = () => {

    const [isExpandedBubble, setIsExpandedBubble] = useSafeState<boolean>(false)
    const src = isExpandedBubble ? '/images/expand.png' : 'images/contract.png';
    const emptyB2bAccount: Partial<B2bAccount> = {
        nanoId: '',
        type: AccountType.FAMILY,
        name: '',
        paymentMode: AccountPaymentMode.CARD,
        stripeID: '',
    }
    const [_, setB2bAccount] = useSafeState<B2bAccount | null>(null)

    return <div className='main-dashboard-container pd-m mt-s'>
        <div className='three-columns-expand-two' onClick={() => setIsExpandedBubble(!isExpandedBubble)}>
            <h3>Create A B2B Account</h3>
            <div />
            <img src={src} alt="arrow" className='expand-contract-esim vertical-align ml-l' />
        </div>
        {isExpandedBubble && <EditB2bAccount accountToEdit={emptyB2bAccount} setAccountToEdit={setB2bAccount} setIsExpandedBubble={setIsExpandedBubble} />}
    </div>
}